import useRouterQueryResolver from 'hooks/router-query-resolver'
export default function DepositPanel() {
  useRouterQueryResolver()
  return ''
}